if (!customElements.get('quick-add-modal')) {
  class QuickAddModal extends HTMLElement {
    constructor() {
      super();
      this.overlay = this.querySelector('.quick-add-modal__overlay');
      this.closeBtn = this.querySelector('.quick-add-modal__close');
    }

    connectedCallback() {
      if (this.overlay) this.overlay.addEventListener('click', () => this.close());
      if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.close());
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.classList.contains('is-open')) this.close();
      });
    }

    open(productUrl) {
      this.classList.add('is-open');
      document.body.style.overflow = 'hidden';

      const content = this.querySelector('.quick-add-modal__content');
      content.innerHTML = '<div style="text-align:center;padding:4rem;"><svg class="spinner" viewBox="0 0 24 24" width="24" height="24"><circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="2" stroke-dasharray="31.4" stroke-linecap="round"><animateTransform attributeName="transform" type="rotate" values="0 12 12;360 12 12" dur="1s" repeatCount="indefinite"/></circle></svg></div>';

      fetch(productUrl + (productUrl.includes('?') ? '&' : '?') + 'section_id=quick-add-content')
        .then(r => r.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const section = doc.querySelector('.quick-add-section-content');
          if (section) {
            content.innerHTML = '<button class="quick-add-modal__close" aria-label="Close"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2"><line x1="4" y1="4" x2="16" y2="16"/><line x1="16" y1="4" x2="4" y2="16"/></svg></button>' + section.innerHTML;
            this.querySelector('.quick-add-modal__close').addEventListener('click', () => this.close());
            this.initForm();
          }
        })
        .catch(() => {
          content.innerHTML = '<p>Could not load product. Please try again.</p>';
        });
    }

    initForm() {
      const form = this.querySelector('form[action="/cart/add"]');
      if (!form) return;

      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const formData = new FormData(form);
        const submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.setAttribute('disabled', '');

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
        })
          .then(r => r.json())
          .then(() => {
            if (submitBtn) {
              submitBtn.textContent = 'Added!';
              setTimeout(() => this.close(), 1000);
            }
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, {});
          })
          .catch(() => {
            if (submitBtn) {
              submitBtn.removeAttribute('disabled');
              submitBtn.textContent = 'Error - Try again';
            }
          });
      });
    }

    close() {
      this.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  customElements.define('quick-add-modal', QuickAddModal);
}

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-quick-add]');
  if (!btn) return;
  e.preventDefault();
  let modal = document.querySelector('quick-add-modal');
  if (!modal) {
    modal = document.createElement('quick-add-modal');
    modal.classList.add('quick-add-modal');
    modal.innerHTML = '<div class="quick-add-modal__overlay"></div><div class="quick-add-modal__content"></div>';
    document.body.appendChild(modal);
  }
  modal.open(btn.dataset.quickAdd);
});
